/**
 *
 */
export { Main as default } from './src/Main'
